
// import React from "react";

// const StepHeader = ({ currentStep = 1, onStepClick }) => {
//     const labels = ["Company", "Contact", "Documents", "Preview"];

//     return (
//         <div style={headerWrapper}>
//             {labels.map((label, i) => {
//                 const step = i + 1;

//                 return (
//                     <div key={i} style={stepWrapper}>

//                         {/* Circle + Label */}
//                         <div
//                             style={{
//                                 ...circleWrapper,
//                                 cursor: "pointer",
//                                 transition: "0.2s"
//                             }}
//                             onClick={() => onStepClick && onStepClick(step)} // 👈 click
//                         >
//                             <div
//                                 style={{
//                                     ...circle,
//                                     background:
//                                         step <= currentStep ? "#e66d33" : "#d1d5db"
//                                 }}
//                             >
//                                 {step}
//                             </div>

//                             <div style={labelStyle}>{label}</div>
//                         </div>

//                         {/* Line */}
//                         {i !== labels.length - 1 && (
//                             <div
//                                 style={{
//                                     ...line,
//                                     background:
//                                         step < currentStep ? "#e66d33" : "#d1d5db"
//                                 }}
//                             />
//                         )}
//                     </div>
//                 );
//             })}
//         </div>
//     );
// };

// export default StepHeader;


// const headerWrapper = {
//     display: "flex",
//     alignItems: "center",
//     background: "#fff",
//     padding: "20px",
//     borderRadius: "12px",
//     boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)"
// };

// const stepWrapper = {
//     display: "flex",
//     alignItems: "center",
//     flex: 1
// };

// const circleWrapper = {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     minWidth: "60px"
// };

// const circle = {
//     width: "35px",
//     height: "35px",
//     borderRadius: "50%",
//     color: "#fff",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontWeight: "600"
// };

// const labelStyle = {
//     marginTop: "6px",
//     fontSize: "12px",
//     color: "#374151"
// };
// const line = {
//     height: "2px",
//     background: "#d1d5db",
//     flex: 1,
//     margin: "0 10px"
// };


import React from "react";

const StepHeader = ({ currentStep = 1, onStepClick }) => {
    const labels = ["Company", "Contact", "Documents", "Location", "Preview"];

    return (
        <div style={headerWrapper}>
            {labels.map((label, i) => {
                const step = i + 1;

                return (
                    <div key={i} style={stepWrapper}>
                        <div
                            style={{
                                ...circleWrapper,
                                cursor: "pointer",
                                transition: "0.2s"
                            }}
                            onClick={() => onStepClick && onStepClick(step)}
                        >
                            <div
                                style={{
                                    ...circle,
                                    background: step <= currentStep ? "#e66d33" : "#d1d5db"
                                }}
                            >
                                {step}
                            </div>
                            <div style={labelStyle}>{label}</div>
                        </div>
                        {i !== labels.length - 1 && (
                            <div
                                style={{
                                    ...line,
                                    background: step < currentStep ? "#e66d33" : "#d1d5db"
                                }}
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default StepHeader;

const headerWrapper = {
    display: "flex",
    alignItems: "center",
    background: "#fff",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)"
};

const stepWrapper = {
    display: "flex",
    alignItems: "center",
    flex: 1
};

const circleWrapper = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: "60px"
};

const circle = {
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "600"
};

const labelStyle = {
    marginTop: "6px",
    fontSize: "12px",
    color: "#374151"
};

const line = {
    height: "2px",
    background: "#d1d5db",
    flex: 1,
    margin: "0 10px"
};